import { useState } from 'react';
import { Box } from '@mui/material';
import { UserList, UserForm, UserPermissionsEditor } from '@lingaai/user-management';
import type { User } from '@lingaai/user-management';

export function UserManagementTab() {
  const [userFormOpen, setUserFormOpen] = useState(false);
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | undefined>();

  const handleAddUser = () => {
    setSelectedUser(undefined);
    setUserFormOpen(true);
  };

  const handleEditUser = (user: User) => {
    setSelectedUser(user);
    setPermissionsDialogOpen(true);
  };

  return (
    <Box>
      <UserList onAddUser={handleAddUser} onEditUser={handleEditUser} />

      <UserForm
        open={userFormOpen}
        onClose={() => {
          setUserFormOpen(false);
          setSelectedUser(undefined);
        }}
        user={selectedUser}
      />

      {selectedUser && (
        <UserPermissionsEditor
          open={permissionsDialogOpen}
          onClose={() => {
            setPermissionsDialogOpen(false);
            setSelectedUser(undefined);
          }}
          user={selectedUser}
        />
      )}
    </Box>
  );
}
